module.exports = __webpack_public_path__ + "static/media/header-homepage-spazi-wemi.ec411270.jpg";